<template>
  <span
    v-click-outside="closeLevelDropDown"
    class="relative flex flex-col select-none"
    @click="toggleLevelDropDown"
  >
    <span class="leading-none">
      Level {{ level }}
    </span>
    <span
      v-if="toggled"
      :class="{
        'top-4': !last,
        'bottom-4': last,
      }"
      class="absolute right-0 flex flex-col border border-roc-blue bg-white z-50 max-h-48 w-32 overflow-y-auto rounded-lg"
    >
      <span
        class="p-2 text-black flex flex-row items-center group cursor-pointer leading-none hover:bg-gray-100 duration-300 transition gap-2"
        @click="changeLevel(30)"
      >
        <i
          :class="{
            'text-white group-hover:text-gray-100': level !== 30,
            'text-black': level === 30
          }"
          class="fas fa-check"
        />
        <span>
          Max
        </span>
      </span>
      <span
        v-for="(l, index) in levels"
        :key="index"
        class="p-2 text-black flex flex-row items-center group cursor-pointer leading-none hover:bg-gray-100 duration-300 transition gap-2"
        @click="changeLevel(l)"
      >
        <i
          :class="{
            'text-white group-hover:text-gray-100': level !== l,
            'text-black': level === l
          }"
          class="fas fa-check"
        />
        <span>
          Level {{ l }}
        </span>
      </span>
    </span>
  </span>
</template>

<script>
import {computed, ref} from 'vue';
import {useApplicationStore} from '@/roc/stores/ApplicationStore';

export default {
  props: {
    wonder: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      required: true
    },
    last: {
      type: Boolean,
      required: true
    }
  },
  emits: ['level'],
  setup(props, context) {
    const toggled = ref(false);

    const appStore = useApplicationStore();

    return {
      toggled,

      editable: computed(() => {
        return appStore.editable;
      }),

      levels: computed(() => {
        const r = [];
        for (let i = 1; i <= 30; i++) {
          r.push(i);
        }
        return r;
      }),

      toggleLevelDropDown() {
        if (appStore.editable) {
          toggled.value = !toggled.value;
        }
      },

      changeLevel(level) {
        context.emit('level', level, props.wonder.id)
      },

      closeLevelDropDown() {
        toggled.value = false;
      }
    };
  }
};
</script>
